import { SeniorityLevelType } from '$types/position/positionPropertyValues';

export const seniorityToExpYears = (
  SeniorityLevel: SeniorityLevelType | ''
) => {
  switch (SeniorityLevel) {
    case SeniorityLevelType.SENIOR:
      return 5;
    case SeniorityLevelType.MID_LEVEL:
      return 3;
    case SeniorityLevelType.ENTRY_LEVEL:
    default:
      return 1;
  }
};

export const expYearsToSeniority = (expYears: number) => {
  if (expYears >= 5) return SeniorityLevelType.SENIOR;
  if (expYears >= 3) return SeniorityLevelType.MID_LEVEL;
  return SeniorityLevelType.ENTRY_LEVEL;
};
